import './assets/utilityStyles.css';//#region lib/utilityStyles.module.css
var e = "_colorNeutralText_ki9oi_2", t = "_colorNeutralSolid_ki9oi_6", n = "_colorErrorText_ki9oi_10", r = "_nowrap_ki9oi_15", i = "_flexCenter_ki9oi_19", a = "_grow_ki9oi_25", o = "_flexFill_ki9oi_29", s = "_width100_ki9oi_34", c = "_anchorUndecorated_ki9oi_39", l = "_cursorPointer_ki9oi_51", u = {
	colorNeutralText: e,
	colorNeutralSolid: t,
	colorErrorText: n,
	nowrap: r,
	flexCenter: i,
	grow: a,
	flexFill: o,
	width100: s,
	anchorUndecorated: c,
	cursorPointer: l
};
//#endregion
export { c as anchorUndecorated, n as colorErrorText, t as colorNeutralSolid, e as colorNeutralText, l as cursorPointer, u as default, i as flexCenter, o as flexFill, a as grow, r as nowrap, s as width100 };
